let onSessionInvalid = null;
let invalidating = false;

export function registerSessionInvalidHandler(handler) {
	onSessionInvalid = handler;
}

export function notifySessionInvalid(reason) {
	if (invalidating || !onSessionInvalid) return;
	invalidating = true;
	onSessionInvalid(reason);
}

export function resetSessionInvalidState() {
	invalidating = false;
}
